import type { Taxonomy } from '@/types/Taxonomy';

export const getBreadcrumbLinkLabel = ({ data }: { data: Taxonomy }): string =>
  data?.breadcrumb_name?.trim().length ? data.breadcrumb_name : data.name;
